import { useEffect, useState } from "react";

const Tabs = ({ tabs, defaultTab, activeTab, hideHeader = false, onChange, className = "" }) => {
  const firstId = defaultTab ?? tabs[0]?.id;
  const isControlled = activeTab !== undefined && activeTab !== null;
  const [activeId, setActiveId] = useState(isControlled ? activeTab : firstId);

  const handleSelect = (id) => {
    if (!isControlled) {
      setActiveId(id);
    }
    onChange?.(id);
  };

  useEffect(() => {
    if (isControlled) {
      setActiveId(activeTab);
    }
  }, [activeTab, isControlled]);

  const currentTab = tabs.find((t) => t.id === activeId) ?? tabs[0];

  return (
    <div className={`flex flex-col ${className}`}>
      {!hideHeader && (
        <div
          className="flex flex-row gap-0 border-b border-[var(--theme-border)]"
          role="tablist"
        >
          {tabs.map((tab) => (
            <button
              key={tab.id}
              role="tab"
              aria-selected={activeId === tab.id}
              aria-controls={`tabpanel-${tab.id}`}
              id={`tab-${tab.id}`}
              type="button"
              className={`px-4 py-2 font-medium border-b-2 -mb-px transition-colors ${
                activeId === tab.id
                  ? "border-[var(--theme-primary)] text-[var(--theme-primary)]"
                  : "border-transparent text-[var(--theme-text-muted)] hover:text-[var(--theme-text)] hover:border-[var(--theme-border)]"
              }`}
              onClick={() => handleSelect(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      )}
      <div
        role="tabpanel"
        id={`tabpanel-${activeId}`}
        aria-labelledby={`tab-${activeId}`}
        className="flex-1 pt-3"
      >
        {currentTab?.children}
      </div>
    </div>
  );
};

export default Tabs;
